module.exports = __webpack_public_path__ + "static/almanacka-meta-card-b6ee0bad61357ba28a057321410f4e25.jpg";